import { render, staticRenderFns } from "./rightMiddle.vue?vue&type=template&id=37e79460&scoped=true&"
import script from "./rightMiddle.vue?vue&type=script&lang=js&"
export * from "./rightMiddle.vue?vue&type=script&lang=js&"
import style0 from "./rightMiddle.vue?vue&type=style&index=0&id=37e79460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e79460",
  null
  
)

export default component.exports